import {
    ResultObj,
    allFetch,
} from "../Domain";
/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} disable 是否禁用
 */
export interface SignOffSettingMasterSearchParams {
    sosm_id?: string;
    disable?: string;
}

export type SignOffSettingMasterSearchResItem = {
    disable: "Y" | "N";
    sosm_id: string;
    sosm_name: string;
}

/**
 * @description 查詢簽核項目
 * @param {SignOffSettingMasterSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingMasterSearch =
    async (obj: SignOffSettingMasterSearchParams): Promise<ResultObj<SignOffSettingMasterSearchResItem[]>> => await allFetch('SignOffSetting/SignOffSettingMasterSearch', obj);


/**
 * @param {*} sosm_id 簽核設定主項流水號
 */
export interface SignOffSettingMasterDetailParams {
    sosm_id: string;
}

export interface SignOffSettingMasterDetailResItem {
    disable: string;
    sosm_id: string;
    sosm_name: string;
}

/**
 * @description 簽核項目細項
 * @param {SignOffSettingMasterDetailParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingMasterDetail = async function (obj: SignOffSettingMasterDetailParams = { sosm_id: "" }): Promise<ResultObj<SignOffSettingMasterDetailResItem[]>> {
    return await allFetch('SignOffSetting/SignOffSettingMasterDetail', obj);
}

/**
 * @param {*} sosm_name 簽核設定主項名稱
 */
export interface SignOffSettingMasterCreateParams {
    sosm_name: string;
}

/**
 * @description 新增簽核設定主項
 * @param {SignOffSettingMasterCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingMasterCreate = async function (obj: SignOffSettingMasterCreateParams = { sosm_name: "" }): Promise<ResultObj<string>> {
    return await allFetch('SignOffSetting/SignOffSettingMasterCreate', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} sosm_name 簽核設定主項名稱
 * @param {*} disable 是否禁用
 */
export interface SignOffSettingMasterUpdateParams {
    sosm_id: string;
    sosm_name: string;
    disable: string;
}

/**
 * @description 修改簽核設定主項
 * @param {SignOffSettingMasterUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingMasterUpdate = async function (obj: SignOffSettingMasterUpdateParams = { sosm_id: "", sosm_name: "", disable: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingMasterUpdate', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 */
export interface SignOffSettingMasterDeleteParams {
    sosm_id: string;
}

/**
 * @description 刪除簽核設定主項
 * @param {SignOffSettingMasterDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingMasterDelete = async function (obj: SignOffSettingMasterDeleteParams = { sosm_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingMasterDelete', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {[]} list 欄位資訊們
 */
export interface SignOffSettingDetailCreateParams {
    sosm_id: string;
    list: {
        /** 欄位名稱*/
        column_name: string,
        /** 欄位是否加密*/
        is_encryption: string,
        /** 欄位是否必填*/
        is_require: string,
        /** 資料型態*/
        data_type: string,
        /** 順序*/
        seq: string,
        /** 是否需通知*/
        is_notice: string
    }[];

}

export interface SignOffSettingDetailCreateResItem {
    /** 欄位名稱*/
    column_name: string,
    /** 欄位是否加密*/
    is_encryption: string,
    /** 欄位是否必填*/
    is_require: string,
    /** 資料型態*/
    data_type: string,
    /** 順序*/
    seq: string,
    /** 是否需通知*/
    is_notice: string
    sosd_id: string;
    sosm_id: string;
}
/**
 * @description (第一次)新增一堆簽核設定細項
 * @param {SignOffSettingDetailCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailCreate = async function (obj: SignOffSettingDetailCreateParams = { sosm_id: "", list: [] }): Promise<ResultObj<SignOffSettingDetailCreateResItem[]>> {
    return await allFetch('SignOffSetting/SignOffSettingDetailCreate', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} column_name 欄位名稱
 * @param {*} is_encryption 欄位是否加密
 * @param {*} is_require 欄位是否必填
 * @param {*} data_type 資料型態
 * @param {*} seq 順序
 */
export interface SignOffSettingDetailAddParams {
    sosm_id: string;
    column_name: string;
    is_encryption: string;
    is_require: string;
    data_type: string;
    seq: number;
    is_notice: string
}

/**
 * @description 增加一條簽核設定細項
 * @param {SignOffSettingDetailAddParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailAdd = async function (obj: SignOffSettingDetailAddParams): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingDetailAdd', obj);
}

/**
 * @param {*} sosd_id 簽核設定細項流水號
 * @param {*} column_name 欄位名稱
 * @param {*} is_encryption 欄位是否加密
 * @param {*} is_require 欄位是否必填
 * @param {*} data_type 資料型態
 * @param {*} seq 順序
 */
export interface SignOffSettingDetailUpdateParams {
    sosd_id: string;
    column_name: string;
    is_encryption: string;
    is_require: string;
    data_type: string;
    seq: number;
}

/**
 * @description 修改簽核設定細項
 * @param {SignOffSettingDetailUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailUpdate = async function (obj: SignOffSettingDetailUpdateParams = { sosd_id: "", column_name: "", is_encryption: "", is_require: "", data_type: "", seq: 0 }): Promise<ResultObj<string>> {
    return await allFetch('SignOffSetting/SignOffSettingDetailUpdate', obj);
}

/**
 * @param {*} sosd_id 簽核設定細項流水號
 */
export interface SignOffSettingDetailDeleteParams {
    sosd_id: string;
}

/**
 * @description 刪除簽核設定細項
 * @param {SignOffSettingDetailDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailDelete = async function (obj: SignOffSettingDetailDeleteParams = { sosd_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingDetailDelete', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 */
export interface SignOffSettingDetailSearchParams {
    sosm_id: string;
}
export type SignOffSettingDetailSearchResItem = {
    column_name: string;
    data_type: string
    is_encryption: "Y" | "N";
    is_notice: "Y" | "N";
    is_require: "Y" | "N";
    seq: number;
    sosd_id: string;
    sosm_id: string;
}

/**
 * @description 查詢簽核設定細項
 * @param {SignOffSettingDetailSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailSearch = async function (obj: SignOffSettingDetailSearchParams = { sosm_id: "" }): Promise<ResultObj<SignOffSettingDetailSearchResItem[]>> {
    return await allFetch('SignOffSetting/SignOffSettingDetailSearch', obj);
}

/**
 * @param {*} sosd_id 簽核設定細項流水號
 * @param {*} option 選項
 */
export interface SignOffSettingDetailOptionCreateParams {
    sosd_id: string;
    option: string;
}

export interface SignOffSettingDetailOptionCreateResItem {
    sosdo_id: string;
    option: string;
}

/**
 * @description 新增簽核設定細項選項
 * @param {SignOffSettingDetailOptionCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailOptionCreate = async function (obj: SignOffSettingDetailOptionCreateParams = { sosd_id: "", option: "" }): Promise<ResultObj<SignOffSettingDetailOptionCreateResItem[]>> {
    return await allFetch('SignOffSetting/SignOffSettingDetailOptionCreate', obj);
}

/**
 * @param {*} sosdo_id 簽核設定細項選項流水號
 * @param {*} sosd_id 簽核設定細項流水號
 * @param {*} option 選項
 */
export interface SignOffSettingDetailOptionUpdateParams {
    sosdo_id: number | string;
    sosd_id: string;
    option: string;
}

/**
 * @description 修改簽核設定細項選項
 * @param {SignOffSettingDetailOptionUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailOptionUpdate = async function (obj: SignOffSettingDetailOptionUpdateParams = { sosdo_id: "", sosd_id: "", option: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingDetailOptionUpdate', obj);
}

/**
 * @param {*} sosdo_id 簽核設定細項選項流水號
 * @param {*} sosd_id 簽核設定細項流水號
 */
export interface SignOffSettingDetailOptionDeleteParams {
    sosdo_id: string | number;
    sosd_id: string;
}

/**
 * @description 刪除簽核設定細項選項
 * @param {SignOffSettingDetailOptionDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailOptionDelete = async function (obj: SignOffSettingDetailOptionDeleteParams = { sosdo_id: "", sosd_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffSettingDetailOptionDelete', obj);
}

/**
 * @param {*} sosd_id 簽核設定細項流水號
 */
export interface SignOffSettingDetailOptionSearchParams {
    sosd_id: string;
}

export type SignOffSettingDetailOptionSearchResItem = {
    option: string;
    sosd_id: string;
    sosdo_id: number;
}

/**
 * @description 查詢簽核設定細項選項
 * @param {SignOffSettingDetailOptionSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffSettingDetailOptionSearch =
    async (obj: SignOffSettingDetailOptionSearchParams): Promise<ResultObj<SignOffSettingDetailOptionSearchResItem[]>> =>
        await allFetch('SignOffSetting/SignOffSettingDetailOptionSearch', obj);

// 簽核審核規則設定

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} audit_type 審核類型
 */
export interface SignOffAuditSettingCreateParams {
    sosm_id: string;
    ul_id: string;
    audit_type: string;
}

/**
 * @description 新建簽核審核規則設定
 * @param {SignOffAuditSettingCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffAuditSettingCreate = async function (obj: SignOffAuditSettingCreateParams = { sosm_id: "", ul_id: "", audit_type: "" }): Promise<ResultObj<string>> {
    return await allFetch('SignOffSetting/SignOffAuditSettingCreate', obj);
}

/**
 * @param {*} soas_id 簽核審核規則設定流水號
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} audit_type 審核類型
 */
export interface SignOffAuditSettingUpdateParams {
    soas_id: string;
    sosm_id: string;
    ul_id: string;
    audit_type: string;
}

/**
 * @description 修改簽核審核規則設定
 * @param {SignOffAuditSettingUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffAuditSettingUpdate = async function (obj: SignOffAuditSettingUpdateParams = { soas_id: "", sosm_id: "", ul_id: "", audit_type: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffAuditSettingUpdate', obj);
}

/**
 * @param {*} soas_id 簽核審核規則設定流水號
 */
export interface SignOffAuditSettingDeleteParams {
    soas_id: string;
}

/**
 * @description 刪除簽核審核規則設定
 * @param {SignOffAuditSettingDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffAuditSettingDelete = async function (obj: SignOffAuditSettingDeleteParams = { soas_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffAuditSettingDelete', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 */
export interface SignOffAuditSettingSearchParams {
    sosm_id: string;
}

export interface SignOffAuditSettingSearchResItem {
    audit_type: string;
    soas_id: string;
    sosm_id: string;
    ul_code: string;
    ul_id: string;
    ul_name: string;
}


/**
 * @description 查詢簽核審核規則設定
 * @param {SignOffAuditSettingSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffAuditSettingSearch = async function (obj: SignOffAuditSettingSearchParams = { sosm_id: "" }): Promise<ResultObj<SignOffAuditSettingSearchResItem[]>> {
    return await allFetch('SignOffSetting/SignOffAuditSettingSearch', obj);
}

// 簽核插入規則設定

/**
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} insert_position 插入位置
 */
export interface SignOffInsertSettingCreateParams {
    sosm_id: string;
    ul_id: string;
    insert_position: string;
}

/**
 * @description 新建簽核插入規則設定
 * @param {SignOffInsertSettingCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffInsertSettingCreate = async function (obj: SignOffInsertSettingCreateParams = { sosm_id: "", ul_id: "", insert_position: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffInsertSettingCreate', obj);
}

/**
 * @param {*} sois_id 簽核插入規則設定流水號
 * @param {*} sosm_id 簽核設定主項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} insert_position 插入位置
 */
export interface SignOffInsertSettingUpdateParams {
    sois_id: string;
    sosm_id: string;
    ul_id: string;
    insert_position: string;
}

/**
 * @description 修改簽核插入規則設定
 * @param {SignOffInsertSettingUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffInsertSettingUpdate = async function (obj: SignOffInsertSettingUpdateParams = { sois_id: "", sosm_id: "", ul_id: "", insert_position: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffInsertSettingUpdate', obj);
}

/**
 * @param {*} sois_id 簽核插入規則設定流水號
 */
export interface SignOffInsertSettingDeleteParams {
    sois_id: string;
}

/**
 * @description 刪除簽核插入規則設定
 * @param {SignOffInsertSettingDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffInsertSettingDelete = async function (obj: SignOffInsertSettingDeleteParams = { sois_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffInsertSettingDelete', obj);
}

/**
 * @param {*} sosm_id 簽核設定主項流水號
 */
export interface SignOffInsertSettingSearchParams {
    sosm_id: string;
}

export interface SignOffInsertSettingSearchResItem {
    sois_id: number;
    sosm_id: string;
    ul_code: string;
    ul_id: string;
    ul_name: string;
    insert_position: string;
}

/**
 * @description 查詢簽核插入規則設定
 * @param {SignOffInsertSettingSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffInsertSettingSearch = async function (obj: SignOffInsertSettingSearchParams = { sosm_id: "" }): Promise<ResultObj<SignOffInsertSettingSearchResItem[]>> {
    return await allFetch('SignOffSetting/SignOffInsertSettingSearch', obj);
}

// 簽核條件規則設定

/**
 * @param {*} sosd_id 簽核設定細項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} threshold 門檻
 */
export interface SignOffConditionSettingCreateParams {
    sosd_id: string;
    ul_id: string;
    threshold: string;
}

/**
 * @description 新建簽核條件規則設定
 * @param {SignOffConditionSettingCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffConditionSettingCreate = async function (obj: SignOffConditionSettingCreateParams = { sosd_id: "", ul_id: "", threshold: "" }): Promise<ResultObj<string>> {
    return await allFetch('SignOffSetting/SignOffConditionSettingCreate', obj);
}

/**
 * @param {*} socs_id 簽核條件規則設定流水號
 * @param {*} sosd_id 簽核設定細項流水號
 * @param {*} ul_id 職務流水號
 * @param {*} threshold 門檻
 */
export interface SignOffConditionSettingUpdateParams {
    socs_id: string;
    sosd_id: string;
    ul_id: string;
    threshold: string;
}

/**
 * @description 修改簽核條件規則設定
 * @param {SignOffConditionSettingUpdateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffConditionSettingUpdate = async function (obj: SignOffConditionSettingUpdateParams = { socs_id: "", sosd_id: "", ul_id: "", threshold: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffConditionSettingUpdate', obj);
}

/**
 * @param {*} socs_id 簽核條件規則設定流水號
 */
export interface SignOffConditionSettingDeleteParams {
    socs_id: string;
}

/**
 * @description 刪除簽核條件規則設定
 * @param {SignOffConditionSettingDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffConditionSettingDelete = async function (obj: SignOffConditionSettingDeleteParams = { socs_id: "" }): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffConditionSettingDelete', obj);
}

/**
 * @param {*} sosm_id  簽核設定主項流水號
 */
export interface SignOffConditionSettingSearchParams {
    sosm_id: string;
}

export interface SignOffConditionSettingSearchResItem {
    column_name: string;
    socs_id: number | string;
    sosd_id: string;
    threshold: string;
    ul_code: string;
    ul_id: string;
    ul_name: string;
}

/**
 * @description 查詢簽核條件規則設定
 * @param {SignOffConditionSettingSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffConditionSettingSearch = async function (obj: SignOffConditionSettingSearchParams): Promise<ResultObj<SignOffConditionSettingSearchResItem[]>> {
    return await allFetch('SignOffSetting/SignOffConditionSettingSearch', obj);
}


/**
 * @param {*} sosm_id  簽核設定主項流水號
 */
export interface SignOffNoticeSettingSearchParams {
    sosm_id: string;
}

export interface SignOffNoticeSettingSearchResItem {
    name: string;
    sons_id: number;
    sosm_id: string;
    ul_code: string;
    ul_id: number;
    ul_name: string;
    user_id: string;
    username: string;
}

/**
 * @description 查詢簽核通知設定
 * @param {SignOffNoticeSettingSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffNoticeSettingSearch = async function (obj: SignOffNoticeSettingSearchParams): Promise<ResultObj<SignOffNoticeSettingSearchResItem[]>> {
    return await allFetch('SignOffSetting/SignOffNoticeSettingSearch', obj);
}



/**
 * @param {*} sosm_id  簽核設定主項流水號
 * @param {*} ul_ids  使用者流水號們 ,
 * @param {*} user_ids  職務流水號們
 */
export interface SignOffNoticeSettingUpdateParams {
    sosm_id: string;
    ul_ids?: string[];
    user_ids?: string[];
}

/**
 * @description 查詢簽核通知設定
 * @param {SignOffNoticeSettingSearchParams} obj
 * @returns {Promise<ResultObj>}
 */
export const SignOffNoticeSettingUpdate = async function (obj: SignOffNoticeSettingUpdateParams): Promise<ResultObj> {
    return await allFetch('SignOffSetting/SignOffNoticeSettingUpdate', obj);
}